import React, { useState, useRef, useEffect } from 'react';
import './PromptSample.css'
export default function PromptSample({ prompt }) {
  const [displayFullJson, setDisplayFullJson] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current && !displayFullJson) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
    if (textareaRef.current && displayFullJson) {
      textareaRef.current.scrollTop = 0;
    }
  }, [displayFullJson]);

  const extractLabels = (prompt) => {
    const labelKeys = [
      'gpt4_label',
      'griffith_label',
      'human_label',
      'human_labels',
      'openai_label',
      'orca_label',
      'gpt4_score_griffith',
      'gpt4_score_openai',
      'gpt4_score_gpt4',
      'eval_score_griffith'
    ];

    const labels = {};

    labelKeys.forEach((key) => {
      if (prompt.data[key] !== undefined) {
        labels[key] = prompt.data[key];
      }
    });
    return JSON.stringify(labels, undefined, 4);
  };

  return (
    <div className="container" key={prompt.fileName}>
      <button onClick={() => setDisplayFullJson(!displayFullJson)}>
        {displayFullJson ? <p>show prompt</p> : <p>show json</p>}
      </button>
      {displayFullJson ?
        <textarea className="promptTextArea"
          ref={textareaRef}
          name="prompts"
          placeholder="Prompts"
          onChange={(x) => { }}
          value={JSON.stringify(prompt, undefined, 4)}
          key="prompt"
        /> :
        <textarea className="promptTextArea"
          ref={textareaRef}
          onChange={(x) => { }}
          value={prompt.data.griffith_prompt}
          key="prompt"
        />}
      <textarea className="promptTextArea"
        onChange={(x) => { }}
        value={extractLabels(prompt)}
        key="labels"
      />
    </div>
  )
};